import React from 'react'
import cx from 'classnames'
import styles from './ExplainerSection.module.scss'
import { Heading } from 'components/basic/Heading'
import { Video } from 'components/basic/Video'
import { amClickedButton } from 'events/amplitude'

interface Props {
	headline?: string
	video: string
	caption: string
	thumb: string
	id: string
}

export const ExplainerSection: React.FC<Props> = (props) => {
	const identifier = props.id.replace(' ', '-').toLowerCase()
	return (
		<section className="inner-paddings-y inner-paddings-x bg-white">
			<div className={cx(styles.content, 'max-1440')}>
				<Heading
					titleClass={styles.header}
					title={props.headline ?? 'See how the Pod technology works'}
					type="h2"
				/>
				<div>
					<Video
						src={props.video}
						caption={props.caption}
						autoplay={false}
						nativeControls={true}
						showControls
						muted={false}
						// preload="metadata"
						className={styles.video}
						onPlay={() => amClickedButton(`Played ${props.id} Video`, `${identifier}-video-button`)}
						onPause={() => amClickedButton(`Paused ${props.id} Video`, `${identifier}-video-button`)}
						thumb={props.thumb}
					/>
				</div>
			</div>
		</section>
	)
}
